export default "__VITE_ASSET__ZDyTJCXs__"